import {getNestedValue, setNestedValue} from "@Common/utils/arr-path";
import {chain}                          from "@Common/utils/fs";

import {applyResultCart} from "../common/apply-result-cart";

export const setNonceCard = (card, {apis}) => ({
    action: async (cart) => {

        const resultCart = await apis.next.cart.updateCart(chain(
            {cartId: cart.cartId},
            (_) => setNestedValue(_, ["removePayments", "creditCards"], getNestedValue(cart, ["appliedPayments", "creditCards"])),
            (_) => setNestedValue(_, ["payments", "creditCards"], [{
                ...card,
                "type": "nonce",
            }]),
        ));

        return {
            change: applyResultCart(resultCart),
        };
    },
});
